import { UNLIMITED_PAGINATION_PARAMS } from 'constants/pagination';
import { Resources } from 'constants/resources';

import { useGetList } from 'react-admin';
import { MerchantProviderSetting } from 'types/embedded/merchantProviderSettings';

type UseMerchantProviderSettingsResult = {
  settings: MerchantProviderSetting[];
  isPending: boolean;
  isLoading: boolean;
};

export const useMerchantProviderSettings = (
  merchantId?: string,
): UseMerchantProviderSettingsResult => {
  const {
    data: settings = [],
    isPending,
    isLoading,
  } = useGetList<MerchantProviderSetting>(
    Resources.MerchantProviderSettings,
    {
      filter: { merchant: merchantId },
      pagination: UNLIMITED_PAGINATION_PARAMS,
    },
    { enabled: !!merchantId },
  );

  return { settings, isPending, isLoading };
};
